import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BasedataService } from './shared/basedata.service';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { BimModelApiService } from './bp/bim-models/bim-model-api.service';

import { BimModelVersionApiService } from './bp/bim-models/bim-model-version-api.service';
import { BpViewService } from './bp-view.service';
import { BimSectionApiService } from './bp/bim-sections/bim-section-api.service';
import { BimModelSelectionService } from './bp/bim-models/bim-model-selection/bim-model-selection.service';
import { BimModelsModalComponent } from './bp/bim-models/bim-model-selection/bim-model-selection-modal/bim-model-selection-modal.component';
import { LoaderModule } from '@mydocma/component-library';
import { TranslateModule } from '@ngx-translate/core';
import {MatIconModule} from '@angular/material/icon';
import { PlanApiService } from './bp/plans/plan-api.service';
import {BimForgeApiService} from "./bp/bim-forge/bim-forge-api.service";
import {BimModelThumbnailService} from "./bp/bim-models/bim-model-thumbnail.service";
import { BimModelsModalItemComponent } from './bp/bim-models/bim-model-selection/bim-model-selection-modal-item/bim-model-selection-modal-item.component';
import { BpConfigService } from './config/bp-config.service';
import {CoAppPaneHeaderComponent} from "./co-app-pane-header/co-app-pane-header.component";
import {MydocmaDynamicFormModule} from "@mydocma/dynamic-form";


@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    LoaderModule,
    MatButtonModule,
    MatIconModule,
    MydocmaDynamicFormModule
  ],
  declarations: [BimModelsModalItemComponent, BimModelsModalComponent, CoAppPaneHeaderComponent],
  providers: [
    BpViewService,
    BasedataService,
    BpConfigService,
  ], exports: [CoAppPaneHeaderComponent]
})
export class CoCommonModule { }
